// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__lKrqH","tooltip__message":"Tooltip_tooltip__message__VT9Z5"};